import React from 'react';
import { API } from '../api';
import { Section } from './ui';

/*
 * What this club is on, from the club's own side.
 *
 * Read-only, and deliberately. A club should be able to see what it is
 * paying for and how much of it is gone without ringing anybody — the
 * alternative is finding out by hitting a wall mid-poster. It cannot change
 * anything here, because what a club is entitled to is a conversation with
 * whoever runs the site, not a switch.
 */

const pct = (used, cap) => (cap > 0 ? Math.min(100, Math.round((used / cap) * 100)) : 0);
const capText = cap => (cap === null || cap === undefined ? '∞' : cap);

function Row({ label, used, cap, extra, note }) {
  const unlimited = cap === null || cap === undefined;
  const full = !unlimited && used >= cap;
  return (
    <div className="sub-meter">
      <div className="sub-meter-head">
        <span className="sub-meter-label">{label}</span>
        <span className={`sub-meter-figure${full ? ' is-full' : ''}`}>
          {used}<span className="sub-meter-of"> / {capText(cap)}</span>
          {extra > 0 && <span className="sub-meter-extra"> +{extra}</span>}
        </span>
      </div>
      <div className="sub-bar">
        <span className={`sub-bar-fill${full ? ' is-full' : ''}`} style={{ width: (unlimited ? 0 : pct(used, cap)) + '%' }} />
      </div>
      <p className="sub-meter-note">{note}</p>
    </div>
  );
}

function ClubPlanPanel({ clubId }) {
  const [sub, setSub] = React.useState(null);

  React.useEffect(() => {
    const qs = clubId ? '?clubId=' + clubId : '';
    fetch(`${API}/api/subscriptions/mine${qs}`)
      .then(r => (r.ok ? r.json() : null))
      .then(setSub)
      .catch(() => setSub(null));
  }, [clubId]);

  if (!sub || sub.error) return null;

  return (
    <Section label="Your plan"
      action={<span className="sub-price">{sub.planLabel}<span className="sub-per"> · {sub.price}/month</span></span>}>
      <div className="sub-meters">
        <Row label="Generations this month"
          used={sub.generations.used} cap={sub.generations.cap} extra={sub.generations.credits}
          note={sub.generations.credits
            ? `Plus ${sub.generations.credits} credits, used once this month's allowance is gone.`
            : 'Poster images made by the model. Resets on the first of the month.'} />
        <Row label="Posters kept"
          used={sub.posters.stored} cap={sub.posters.cap}
          note="Delete posters you have finished with to make room for new ones." />
        <Row label="Photos kept"
          used={sub.photos.stored} cap={sub.photos.cap}
          note="Uploaded photographs. Counted apart from generated posters." />
        <Row label="Members"
          used={sub.members.count} cap={sub.members.cap}
          note="Guests entered for a competition do not count towards this." />
        <Row label="Admin accounts"
          used={sub.admins.count} cap={sub.admins.cap}
          note="People who can administer this club." />
      </div>
      <p className="w3-text-grey" style={{ marginTop: 'var(--gs-space-4)', fontSize: 'var(--gs-text-sm)' }}>
        Need more room or more generations? Get in touch with whoever looks after GreenSheet
        for your club.
      </p>
    </Section>
  );
}

export default ClubPlanPanel;
